import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Button,
  Chip,
  CopyToClipboard,
  CustomFileInput,
  CustomInput,
  CustomSelect,
  DevNote,
  Divider,
  DocumentsList,
  FormFieldSet,
  HeaderCard,
  InfoCardNewAdv,
  InfoTimeCard,
  InvoiceSidebar,
  KeyValue,
  LogoLoader,
  NewTable,
  PageHeader,
  PageTab,
  PageTitle,
  showToast,
  Tag,
  useFormHandler,
} from "../../../components";
import InvoiceSidebar2 from "../../../components/Sidebar/InvoiceSidebar2";
import { useNavigate, useLocation } from "react-router-dom";
import InvoicedetailsModal from "./AccountsPayable/PaidBills/Models/InvoicedetailsModal";
import { v4 as uuidv4 } from "uuid";
import {
  InvoiceBy,
  PayableCategory,
  PayableType,
} from "../../../assets/data/enumData";
import { useDispatch, useSelector } from "react-redux";
import { useLoginUser } from "../../../hooks/useLoginUser";
import {
  clearVendorData,
  getVendorOneStart,
} from "../../../redux/slices/vendor/vendorSlice";
import {
  addAccountPayablesStart,
  clearAccountPayablesData,
  getAccountPayablesOneStart,
  setAccountPayablesProfile,
  updateAccountPayablesStart,
} from "../../../redux/slices/accountPayables/accountPayablesSlice";
import { uploadStart } from "../../../redux/slices/universal/fileUploadSlice";
import { useParams } from "react-router-dom";
import { addDocumentStart } from "../../../redux/slices/universal/documentsSlice";
import { getEmployeeId } from "../../../utils";
import { getClientId, getVendorId } from "../../../utils/getClientId";
import {
  clearEmployeeData,
  getEmployeeByUiidStart,
} from "../../../redux/slices/employee/employeeSlice";
import {
  clearTimesheetData,
  getTimesheetsStart,
} from "../../../redux/slices/timesheets/timsheetSlice";
import {
  clearBillPayments,
  qbApiStart,
} from "../../../redux/slices/quickBooks/quickBooksSlice";
import { ENDPOINTS, WORKFORCE_API_URL } from "../../../redux/apiConfig";
import axios from "axios";
import { formatCurrency, formatWords2 } from "../../../utils/stringUtils";
import axiosRequest from "../../../redux/slices/universal/axiosService";
import { div } from "framer-motion/client";

const CreateAccountsPayableInvoice = () => {
  const { payableId } = useParams();
  const dispatch = useDispatch();
  const { userData: loginUserData } = useLoginUser();
  const loginUserUiid = loginUserData?.uiid;

  const { billpayments, loading: billpaymentsLoading } = useSelector(
    (state) => state.quickBooks,
  );

  const { employeeDetails: currentEmployeeDetails } = useSelector(
    (state) => state.employee.currentEmployee,
  );
  const vendorDetails = useSelector(
    (state) => state.vendor.currentVendor.vendorDetails,
  );
  const currentAccountsPayables = useSelector(
    (state) => state.accountPayables.currentAccountPayables.details,
  );

  const accountPayablesProfileUiid = useSelector(
    (state) => state.accountPayables.accountPayablesProfileUiid,
  );
  const loading = useSelector((state) => state.accountPayables.loading);

  const [tableData, setTableData] = useState([]);
  const [currentPlacementPayRate, setCurrentPlacementPayRate] = useState(0);
  const [currentTimesheetFetchingType, setCurrentTimesheetFetchingType] =
    useState("");
  const [currentPlacementId, setCurrentPlacementId] = useState("");
  const [placementLastPay, setPlacementLastPay] = useState({});
  const [model, setmodel] = useState(false);
  const [docs, setDocs] = useState([]);
  const [kpiLoading, setKpiLoading] = useState(false);

  // invoice amount === grand total
  //bill amount == subtotal
  const [selectedValues, setSelectedValues] = useState([]);
  const [invoiceAmount, setInvoiceAmount] = useState(0.0);
  const navigate = useNavigate();
  const location = useLocation();
  const fromModal = location.state?.fromModal ?? false;
  const handleBack = () => {
    if (fromModal) {
      navigate(-1);
    } else {
      navigate("/accounts-payable");
    }
  };
  // const handleBack = () => {
  //   navigate("/accounts-payable");
  // };
  const handelinvoice = () => {
    setmodel(!model);
  };
  const {
    loading: timeSheetLoading,
    error,
    timesheets,
    totalCount,
  } = useSelector((state) => state.timesheet);
  const {
    formData,
    errors,
    handleChange,
    setFormData,
    setErrors,
    validateAllFields,
  } = useFormHandler(
    {
      PayableCategory: "",
      PayableType: "",
      // ApprovalFlow: "",
      // ApprovalFlow: "",
      InvoiceBy: "",
      Vendor: "",
      Contractors: "",
      MailingAddress: "",
      InvoiceNumber: "",
      NetTerms: "",
      BillDate: "",
      DueDate: "",
      InvoiceDate: "",
      BillAmount: null,
      // InvoiceContacts: "",
      InvoiceContacts: [],
      InvoiceContactEmails: "",

      attachments: [
        {
          id: uuidv4(),
          comments: "",
          chooseFiles: [],
        },
      ],

      discounts: [
        {
          id: uuidv4(),
          name: "",
          type: "",
          discount: null,
          editable: true,
        },
      ],
    },
    {
      PayableCategory: { type: "select", required: true },
      PayableType: { type: "select", required: true },
      InvoiceBy: { type: "select", required: true },
      Vendor: { type: "select", required: true },
      Contractors: { type: "select", required: true },
      InvoiceNumber: { type: "text", required: true },
      attachments: [{ chooseFiles: { type: "file" } }],
    },
  );
  useEffect(() => {
    if (formData.Vendor.value) {
      dispatch(
        getVendorOneStart({
          vendorUiid: formData.Vendor.value,
          ref: "Contact",
          retrieve: "generalInfo contacts",
        }),
      );
    }
    console.log(
      "currentTimesheetFetchingType in useffect",
      currentTimesheetFetchingType,
    );
    if (formData.Contractors.value) {
      if (currentTimesheetFetchingType === "direct") {
        dispatch(
          getTimesheetsStart({
            filters: {
              employeeId: { type: "NONE", value: formData.Contractors.value },
              status: { type: "NONE", value: 6 },
              invoiceId: { type: "EXCLUDE", value: [] },
            },
            ret: "uiid period employeeId placementId clientId invoiceId periodCycle status dailyEntries",
            ref: "Invoice Placement",
            incl: ["serviceSummary finalBill.discounts"],
          }),
        );
      } else if (currentTimesheetFetchingType === "referral") {
        const fetchInvoicesForTimesheets = async () => {
          try {
            let filter = {
              employeeId: { type: "NONE", value: formData.Contractors.value },
              jobId: { type: "NONE", value: currentPlacementId },
              "amounts.due": { type: "NONE", value: 0 },
              status: { type: "NONE", value: 3 },
            };
            const response = await axiosRequest({
              method: "GET",
              url: ENDPOINTS.INVOICES.GET_ALL,
              params: {
                coll: "Invoice",
                ret: "timesheetRef",
                // ref: "ReferredId Placement",
                // incl: ["firstName lastName employmentType uiid", "jobInfo"],
                fil: JSON.stringify(filter),
                lim: 100,
                pg: 1,
              },
            });
            console.log("refrral invoice resposne", response?.data?.data);
            let responseInvoiceWithTS = response?.data?.data || [];
            const timesheetIds = responseInvoiceWithTS?.flatMap((entry) =>
              entry.timesheetRef.map((ref) => ref.id),
            );
            const timesheetIdSet = new Set(timesheetIds);
            console.log("all timeshetids set", timesheetIdSet);
            dispatch(
              getTimesheetsStart({
                filters: {
                  uiid: { type: "IN", value: Array.from(timesheetIdSet) },
                  employeeId: {
                    type: "NONE",
                    value: formData.Contractors.value,
                  },
                  // status: { type: "NONE", value: 6 },
                  // invoiceId: { type: "EXCLUDE", value: [] },
                },
                ret: "uiid period employeeId placementId clientId invoiceId periodCycle status dailyEntries",
                ref: "Invoice Placement",
                incl: ["serviceSummary finalBill.discounts"],
              }),
            );
          } catch (error) {
            showToast("Failed to fetch timesheet data", "error");
            console.log("Error fetching timesheets:", error);
          }
        };
        fetchInvoicesForTimesheets();
      }

      dispatch(
        getEmployeeByUiidStart({
          uiid: formData.Contractors.value,
          ref: "Approver",
        }),
      );
    }

    return () => {
      dispatch(clearVendorData());
      dispatch(clearTimesheetData());
    };
    // }, [formData.Vendor.value, formData.Contractors.value]);
  }, [formData.Vendor.value, formData.Contractors]);

  useEffect(() => {
    if (formData.Vendor.value && vendorDetails) {
      const billing =
        vendorDetails?.generalInfo?.locations?.find(
          (loc) => loc.isDefaultBilling,
        ) || {};
      const mailing = [
        billing.address1,
        billing.address2,
        billing.city,
        billing.state,
        billing.zipCode,
        billing.country,
      ]
        .filter(Boolean)
        .join("\n");

      handleChange("MailingAddress", mailing);
      handleChange("NetTerms", vendorDetails?.generalInfo?.netTerms || "");

      const phones = vendorDetails?.contacts
        ?.map((c) => c.phone?.work)
        .filter((p) => p?.code && p?.number)
        .map(({ code, number }) => ({ code, number }));
      handleChange("InvoiceContacts", phones);

      const emails = vendorDetails?.contacts?.map((c) => c.email) || [];
      handleChange("InvoiceContactEmails", emails);
    }
  }, [formData.Vendor.value, vendorDetails]);

  useEffect(() => {
    const approver = currentEmployeeDetails?.approvalFlow?.approvers?.[0];
    if (approver) {
      const name = [
        approver.firstName,
        approver.lastName,
        `(${getEmployeeId(approver.uiid, approver.employementType)})`,
      ]
        .filter(Boolean)
        .join(" ");
      handleChange("ApprovalFlow", {
        label: name,
        value: approver.uiid,
      });
    }
    return () => dispatch(clearEmployeeData());
  }, [currentEmployeeDetails?.approvalFlow?.approvers]);

  useEffect(() => {
    if (payableId) {
      dispatch(
        getAccountPayablesOneStart({
          accountPayableUiid: payableId,
          ref: "Employee Vendor Document Approver InvClient InvVendor",
          incl: [
            "firstName lastName employmentType",
            "businessName",
            "",
            "firstName lastName employementType",
            "businessName uiid",
            "businessName uiid",
          ],
        }),
      );
    }
    return () => dispatch(clearAccountPayablesData());
  }, [payableId]);

  useEffect(() => {
    if (!currentAccountsPayables.uiid) return;
    const data = { ...currentAccountsPayables };

    const approverLabel = data.approverId?.firstName
      ? `${data.approverId.firstName} ${
          data.approverId.lastName
        } (${getEmployeeId(
          data.approverId.uiid,
          data.approverId.employementType,
        )})`
      : null;

    handleChange("ApprovalFlow", {
      label: approverLabel,
      value: data.approverId?.uiid,
    });

    handleChange("PayableCategory", data.category || "");
    handleChange("PayableType", data.type || "");
    handleChange("InvoiceBy", data.invoiceBy || "");
    handleChange("Vendor", data.vendorId || "");
    handleChange("Contractors", data.employeeId || "");
    handleChange("MailingAddress", data.mailAddress || "");
    handleChange("InvoiceNumber", data.invoiceNum || "");
    handleChange("NetTerms", data.netTerms || "");
    handleChange("BillDate", data.billedDate || "");
    handleChange("DueDate", data.dueDate || "");
    handleChange("InvoiceDate", data.invoiceDate || "");
    handleChange(
      "BillAmount",
      data.amounts?.billed + data.amounts?.discount || "",
    );
    handleChange("InvoiceContacts", data.contacts || "");
    handleChange("InvoiceContactEmails", data.emails || "");
    handleChange(
      "discounts",
      Array.isArray(data.discount)
        ? data.discount.map((d, i) => ({
            id: d._id || i,
            name: d.name || "",
            type: d.type || "",
            discount: d.value || "",
          }))
        : [],
    );
    handleChange("Comments", data.comments || "");
    handleChange("StatmentMemo", data.memo || "");

    const rows = (data.invoiceDetails || []).map((item, i) => {
      const isClientId = typeof item.clientId !== "undefined";
      const isVendorId = typeof item.vendorId !== "undefined";
      const entityId = isClientId
        ? item.clientId
        : isVendorId
          ? item.vendorId
          : {};
      const isEntityObj = typeof entityId === "object" && entityId !== null;
      return {
        id: item._id || i,
        Amount: item.amount || 0,
        Description: formatWords2(item.description) || "",
        Quantity: item.quantity || 0,
        Rate: item.rate || 0,
        productService: formatWords2(item.service) || "",
        editable: false,
        Client: {
          label: isEntityObj
            ? (entityId?.businessName ?? "")
            : (entityId ?? ""),
          value: isEntityObj
            ? (entityId?.uiid ?? entityId ?? null)
            : (entityId ?? null),
          coll: isClientId ? "Client" : isVendorId ? "Vendor" : null,
        },
      };
    });
    setTableData(rows);

    const files = (data.documents || []).flatMap((doc) =>
      doc.file.flatMap((f) =>
        f.keys.map((k) => ({ name: f.name, filePath: k })),
      ),
    );
    setDocs(files);
  }, [currentAccountsPayables]);

  useEffect(() => {
    const bill = Number(formData.BillAmount) || 0;
    const discountSum = (formData.discounts || []).reduce((acc, d) => {
      return (
        acc +
        (d.type === 1
          ? (bill * Number(d.discount || 0)) / 100
          : Number(d.discount || 0))
      );
    }, 0);
    setInvoiceAmount(bill.toFixed(2));
  }, [formData.BillAmount, formData.discounts]);

  useEffect(() => {
    const ids = (selectedValues || []).map((v) => v.uiid);
    // if (!formData.Vendor.value || !formData.Contractors.value || !ids.length)
    if (!formData.Vendor.value || !formData.Contractors.value) return;

    const fetchClient = async () => {
      try {
        const res = await axios({
          method: "GET",
          url: `${WORKFORCE_API_URL}/placements/get`,
          params: {
            coll: "Placement",
            fil: JSON.stringify({
              "vendor.id": { type: "NONE", value: formData.Vendor.value },
              employeeId: { type: "NONE", value: formData.Contractors.value },
            }),
            ret: "jobInfo",
            ref: "Client",
            incl: "businessName",
          },
          withCredentials: true,
        });
        return res?.data?.data?.jobInfo?.billClient || {};
      } catch (error) {
        return null;
      }
    };

    const extractServiceSummary = (data, payRate = 0) => {
      return (data || []).flatMap((inv) =>
        (inv.serviceSummary || []).map((summary, i) => ({
          id: summary._id || i,
          // Amount: summary.amount || 0,
          Amount: summary.quantity * payRate || 0,
          Description: summary.activity || "",
          Quantity: summary.quantity || 0,
          Rate: payRate || 0,
          productService: summary.ss || "",
          editable: false,
        })),
      );
    };

    fetchClient()
      .then((client) => {
        const timesheetData =
          timesheets?.data?.filter((t) => ids.includes(t.uiid)) || [];
        let payRate;
        if (currentTimesheetFetchingType === "direct") {
          payRate = currentPlacementPayRate;
        } else if (currentTimesheetFetchingType === "referral") {
          let vendorReferral =
            placementLastPay?.referral?.find(
              (e) => e.vendorId === formData.Vendor.value,
            ) || {};
          //
          let billRate = placementLastPay?.billRate.rate || 0;
          let afterDeduction = billRate || 0;
          let vmsCharges = placementLastPay?.vmsCharges || 0;
          if (parseInt(vmsCharges) > 0)
            afterDeduction =
              parseInt(billRate) * (1 - parseInt(vmsCharges) / 100);
          let deducted = afterDeduction;
          //
          let vendorReferralAmount = vendorReferral?.referralAmount || 0;
          let vendorReferralAmountType =
            vendorReferral?.referralAmountType || 0;
          payRate = vendorReferral?.margin
            ? vendorReferralAmount
            : vendorReferralAmountType === 1
              ? vendorReferralAmount
              : (deducted * vendorReferralAmount) / 100;
        }
        const invoiceDetails = timesheetData.flatMap((t) => t.invoiceId || []);
        const summaryData = extractServiceSummary(invoiceDetails, payRate).map(
          (s) => ({
            ...s,
            Client: {
              label: client.businessName || "",
              value: client.uiid || "",
              coll: "Client",
            },
          }),
        );
        setTableData(summaryData);
        // setTableData((prev) => [...prev, ...summaryData]);
        const allDiscounts = invoiceDetails.flatMap(
          (i) => i?.finalBill?.discounts || [],
        );
        handleChange(
          "discounts",
          allDiscounts.map((d, i) => ({
            id: d._id || i,
            name: d.name || "",
            type: d.type || "",
            discount: d.value || "",
            editable: false,
          })),
        );
      })
      .catch(() => {
        const timesheetData =
          timesheets?.data?.filter((t) => ids.includes(t.uiid)) || [];
        let payRate;
        if (currentTimesheetFetchingType === "direct") {
          payRate = currentPlacementPayRate;
        } else if (currentTimesheetFetchingType === "referral") {
          let vendorReferral =
            placementLastPay?.referral?.find(
              (e) => e.vendorId === formData.Vendor.value,
            ) || {};
          //
          let billRate = placementLastPay?.billRate.rate || 0;
          let afterDeduction = billRate || 0;
          let vmsCharges = placementLastPay?.vmsCharges || 0;
          if (parseInt(vmsCharges) > 0)
            afterDeduction =
              parseInt(billRate) * (1 - parseInt(vmsCharges) / 100);
          let deducted = afterDeduction;
          //
          let vendorReferralAmount = vendorReferral?.referralAmount || 0;
          let vendorReferralAmountType =
            vendorReferral?.referralAmountType || 0;
          payRate = vendorReferral?.margin
            ? vendorReferralAmount
            : vendorReferralAmountType === 1
              ? vendorReferralAmount
              : (deducted * vendorReferralAmount) / 100;
        }
        const invoiceDetails = timesheetData.flatMap((t) => t.invoiceId || []);
        const summaryData = extractServiceSummary(invoiceDetails, payRate).map(
          (s) => ({
            ...s,
            // Client: {
            //   label: client.businessName || "",
            //   value: client.uiid || "",
            //   coll: "Client",
            // },
          }),
        );
        setTableData(summaryData);
        // setTableData((prev) => [...prev, ...summaryData]);
        const allDiscounts = invoiceDetails.flatMap(
          (i) => i?.finalBill?.discounts || [],
        );
        handleChange(
          "discounts",
          allDiscounts.map((d, i) => ({
            id: d._id || i,
            name: d.name || "",
            type: d.type || "",
            discount: d.value || "",
            editable: false,
          })),
        );
      });
  }, [selectedValues]);

  useEffect(() => {
    if (tableData?.length) {
      const total = tableData.reduce(
        (sum, row) => sum + (Number(row.Amount) || 0),
        0,
      );
      handleChange("BillAmount", total);
    }
  }, [tableData]);

  useEffect(() => {
    const qbPayments = currentAccountsPayables?.qbPayments || [];
    if (!qbPayments.length) return;

    const txnIds = qbPayments.map((p) => Number(p.txnId));
    dispatch(
      qbApiStart({
        method: "GET",
        entity: "billpayments",
        params: {
          fil: JSON.stringify({ Id: { type: "IN", value: txnIds } }),
          ret: "Id TotalAmt TxnDate",
        },
      }),
    );

    return () => dispatch(clearBillPayments());
  }, [JSON.stringify(currentAccountsPayables?.qbPayments)]);
  // const handleRowChange = (rowId, field, value) => {
  //   const newValue = value?.target?.value ?? value;
  //   setTableData2((prevData) =>
  //     prevData.map((row) =>
  //       row.id === rowId ? { ...row, [field]: newValue || "" } : row
  //     )
  //   );
  // };

  //   const handleRowChange = (rowId, field, value) => {
  //   const newValue = value?.target?.value ?? value;
  //   setTableData((prevData) =>
  //     prevData.map((row) =>
  //       row.id === rowId ? { ...row, [field]: newValue || "" } : row
  //     )
  //   );
  // };
  // const handleAddRow = () => {
  //   const newRow = {
  //     // id: Date.now().toString(),
  //     // documentType: "",
  //     // invoiceOnBillRate: "",
  //     // invoiceOnPayRate: "",
  //     // receivedOnBillRate: "",
  //     // receivedOnPayRate: "",
  //     id: 1,
  //     productService: "",
  //     Description: "",
  //     Quantity: "",
  //     Rate: "",
  //     Amount: "",
  //     Client: "",
  //   };
  //   setTableData2((prev) => [...prev, newRow]);
  // };
  // const handleRemoveRow = (rowId) => {
  //   setTableData2((prev) => {
  //     const updatedRows = prev.filter((row) => row.id !== rowId);
  //     return updatedRows.length > 0 ? updatedRows : prev;
  //   });
  // };

  // const handleEditRow = (rowId) => {
  //   setTableData((prevData) =>
  //     prevData.map((row) =>
  //       row.id === rowId ? { ...row, editing: !row.editing } : row
  //     )
  //   );
  // };

  const handleRowChange = (rowId, field, value) => {
    const newValue = value?.target?.value ?? value;
    setTableData((prevData) =>
      prevData.map((row) =>
        row.id === rowId ? { ...row, [field]: newValue || "" } : row,
      ),
    );
  };

  const handleAddRow = () => {
    // if (isEdit) {
    const newRow = {
      //     id: 1,

      id: uuidv4(),
      // ss: "",
      // activity: "",
      // quantity: "",
      // rate: "",
      // amount: "",

      // attachment: [],
      productService: "",
      Description: "",
      Quantity: "",
      Rate: "",
      Amount: null,
      Client: "",
      editable: true,
    };
    setTableData((prev) => [...prev, newRow]);
    // }
  };

  const handleRemoveRow = (rowId) => {
    setTableData((prev) => {
      const updatedRows = prev.filter((row) => row.id !== rowId);
      return updatedRows.length > 0 ? updatedRows : prev;
    });
  };
  const handleEditRow = (rowId) => {
    setTableData((prevData) =>
      prevData.map((row) =>
        row.id === rowId ? { ...row, editing: !row.editing } : row,
      ),
    );
  };

  const handleFieldChange = (index, field, value) => {
    handleChange(`attachments[${index}].${field}`, value);
  };
  const getAttachmentError = (index, field) => {
    return errors?.attachments?.[index]?.[field] || "";
  };
  const handleRemoveRowattach = (id) => {
    if (formData.attachments.length > 1) {
      // Find the index of the row to be removed
      const indexToRemove = formData.attachments.findIndex(
        (row) => row.id === id,
      );

      // Update formData directly
      const newDocumentRows = formData.attachments.filter(
        (row) => row.id !== id,
      );

      setFormData({
        ...formData,
        attachments: newDocumentRows,
      });

      // Update the errors state to remove errors for the deleted row
      if (errors?.attachments) {
        setErrors((prevErrors) => {
          const newErrors = { ...prevErrors };

          if (newErrors.attachments) {
            // Remove the errors for the removed index
            const updatedRowErrors = [...newErrors.attachments];
            updatedRowErrors.splice(indexToRemove, 1);
            newErrors.attachments = updatedRowErrors;
          }

          return newErrors;
        });
      }
    }
  };
  const handleAddRowattach = () => {
    // Store current errors
    const currentErrors = { ...errors };

    // Update formData directly instead of using handleChange
    setFormData({
      ...formData,
      attachments: [
        ...formData.attachments,
        {
          id: uuidv4(),
          // title: "",
          // comments: "",
          // status: "",
          // expiryDate: "",
          // chooseFiles: [],
          productService: "",
          Description: "",
          Quantity: "",
          Rate: "",
          Amount: "",
          Client: "",
        },
      ],
    });

    // Make sure to preserve errors
    setErrors(currentErrors);
  };

  const handleAddDiscount = () => {
    handleChange("discounts", [
      ...formData.discounts,
      {
        id: uuidv4(),
        name: "",
        type: "",
        discount: "",
        editable: true,
      },
    ]);
  };

  const handleRemoveDiscount = (id, editable) => {
    if (!editable) {
      return;
    }
    if (formData.discounts.length > 1) {
      handleChange(
        "discounts",
        formData.discounts.filter((item) => item.id !== id),
      );
    }
  };

  const handleDiscountFieldChange = (id, field, value) => {
    handleChange(
      "discounts",
      formData.discounts.map((item) =>
        item.id === id ? { ...item, [field]: value } : item,
      ),
    );
  };
  const handleSave = (status) => {
    // return;
    const isValid = validateAllFields();
    const numberInvoiceAmount = Number(invoiceAmount);
    if (!numberInvoiceAmount) {
      showToast("Invoice amount should be a number. Please correct the value", "error");
    }
    if (isValid) {
      let payload;
      if (payableId) {
        payload = {
          _skipFlatten: ["approverId", "invoiceDetails", "discount"],
          invoiceNum: formData?.InvoiceNumber || undefined,
          invoiceBy: formData?.InvoiceBy || undefined,
          vendorId: formData?.Vendor.value
            ? formData.Vendor?.value
            : formData.Vendor?.uiid || undefined,
          employeeId:
            formData?.Contractors?.value || formData?.Contractors?.[0]?.uiid
              ? [
                  formData?.Contractors?.value ||
                    formData?.Contractors?.[0]?.uiid,
                ]
              : undefined,

          approverId:
            formData?.ApprovalFlow?.value ||
            formData?.ApprovalFlow?.uiid ||
            undefined, // later will setup after correct info
          //first it has component for the invoice date
          // invoiceDate: formData.InvoiceDate || undefined,

          //as said incoive date is same a s billed dated
          invoiceDate: formData?.BillDate || undefined,
          billedDate: formData?.BillDate || undefined,
          dueDate: formData?.DueDate || undefined,
          netTerms: formData?.NetTerms || undefined,
          amounts: {
            billed: numberInvoiceAmount,
            // paid: 0,
            // discount: formData?.discounts?.reduce(
            //   (acc, curr) => acc + Number(curr.discount),
            //   0
            // ),
            // discount: formData?.discounts?.reduce((acc, discount) => {
            //   const value =
            //     discount.type === 1
            //       ? (Number(formData.BillAmount) * Number(discount.discount)) /
            //         100
            //       : Number(discount.discount);
            //   return acc + value;
            // }, 0),
            // due: numberInvoiceAmount,
          },
          isModify: true,
          status:
            status == "draft"
              ? 1
              : status == "save"
                ? 2
                : undefined || undefined,
          category: formData?.PayableCategory || undefined,
          type: formData?.PayableType || undefined,
          mailAddress: formData?.MailingAddress || undefined,
          contacts: formData?.InvoiceContacts || undefined,
          emails: formData?.InvoiceContactEmails || undefined,
          invoiceDetails: tableData?.map((item) => ({
            service: item?.productService || undefined,
            description: item?.Description || undefined,
            quantity: Number(item?.Quantity) || undefined,
            rate: Number(item?.Rate) || undefined,
            amount: Number(item?.Amount) || undefined,
            // clientId: Number(item?.Client?.value) || undefined,
            // entityId: Number(item?.Client?.value) || undefined,
            // entityType: item?.Client?.coll || undefined,
            clientId:
              item?.Client?.coll === "Client"
                ? Number(item?.Client?.value)
                : undefined,
            vendorId:
              item?.Client?.coll === "Vendor"
                ? Number(item?.Client?.value)
                : undefined,
            // isTaxed: false,
            // accType: "",
          })),
          discount:
            formData?.discounts?.map((item) => ({
              name: item?.name || undefined,
              type: item?.type || undefined,
              value: Number(item?.discount) || undefined,
            })) || [],
          memo: formData?.StatmentMemo || undefined,
          comments: formData?.Comments || undefined,
        };
        dispatch(
          updateAccountPayablesStart({
            coll: "AccountPayable",
            uiid: accountPayablesProfileUiid,
            payload: [
              {
                type: "SET",
                value: payload,
              },
            ],
            onSuccess: async (resData) => {
              dispatch(setAccountPayablesProfile(payload));
              // for file upload
              if (
                Array.isArray(formData?.attachments) &&
                formData.attachments.some(
                  (attachment) =>
                    Array.isArray(attachment.chooseFiles) &&
                    attachment.chooseFiles.length > 0,
                )
              ) {
                const cleanAttachments = formData.attachments.filter(
                  (att) => att.chooseFiles && att.chooseFiles.length > 0,
                );
                // Map files with their parent doc id
                const cleanAttachmentsFiles = cleanAttachments.flatMap((doc) =>
                  doc.chooseFiles.map((file) => {
                    file.id = doc.id;
                    return file;
                  }),
                );
                dispatch(
                  uploadStart({
                    uploadType: "multiple",
                    field: "doc",
                    coll: "AccountPayable",
                    uiid: currentAccountsPayables.uiid,
                    entity: "accountPayables",
                    category: "AccountPayable",
                    doc: cleanAttachmentsFiles,
                    onSuccess: async (fileData) => {
                      dispatch(
                        addDocumentStart({
                          coll: "Document",
                          refColl: "AccountPayable",
                          refId: currentAccountsPayables.uiid,
                          // refField: `documents.$[elem].list`,
                          refField: `documents`,
                          // refPatchId: updateRes.targetPatchId,
                          isRefFieldArray: true,
                          payload: {
                            addedBy: loginUserUiid,
                            attachments: [
                              {
                                addedBy: loginUserUiid,
                                parent: {
                                  client: formData.Vendor.value,
                                },
                                // docType: formData.documentType,
                                // docType: formData.documentType.value,
                                ref: {
                                  id: currentAccountsPayables.uiid,
                                  entity: "AccountPayable",
                                  path: `documents`,
                                },
                                file: formData.attachments.map((obj) => ({
                                  // id: obj.id,
                                  name: obj.title,
                                  // comments: obj.attachmentComments,
                                  // status: obj.documentStatus,
                                  // expiry: obj.expiryDate,
                                  // addedBy: loginUserUiid,
                                  keys: fileData.map((file) => file.key),
                                })),
                              },
                            ],
                          },
                          onSuccess: (docRes) => {
                            dispatch(
                              getAccountPayablesOneStart({
                                accountPayableUiid: payableId,
                                ref: "Employee Vendor Document Approver Client",
                                incl: [
                                  "firstName lastName employmentType",
                                  "businessName",
                                  "",
                                  "firstName lastName employementType",
                                  "businessName uiid",
                                ],
                              }),
                            );
                            navigate(-1);
                          },
                        }),
                      );
                    },
                  }),
                );
              } else {
                dispatch(
                  getAccountPayablesOneStart({
                    accountPayableUiid: payableId,
                    ref: "Employee Vendor Document Approver Client",
                    incl: [
                      "firstName lastName employmentType",
                      "businessName",
                      "",
                      "firstName lastName employementType",
                      "businessName uiid",
                    ],
                  }),
                );
                navigate(-1);
              }
            },
          }),
        );
      } else {
        payload = {
          _skipFlatten: ["approverId", "invoiceDetails", "discount"],
          invoiceNum: formData.InvoiceNumber || undefined,
          invoiceBy: formData.InvoiceBy || undefined,
          vendorId: formData.Vendor.value || undefined,
          // employeeId: [formData.Contractors.value] || undefined,
          employeeId:
            formData?.Contractors?.value || formData?.Contractors?.[0]?.uiid
              ? [
                  formData?.Contractors?.value ||
                    formData?.Contractors?.[0]?.uiid,
                ]
              : undefined,
          approverId: formData.ApprovalFlow.value || undefined, // later will setup after correct info
          // invoiceDate: formData.InvoiceDate || undefined,
          //as said incoive date is same a s billed dated
          invoiceDate: formData.BillDate || undefined,
          billedDate: formData.BillDate || undefined,
          dueDate: formData.DueDate || undefined,
          netTerms: formData.NetTerms || undefined,
          amounts: {
            billed: numberInvoiceAmount,
            paid: 0,
            //to calculate discounts also
            // discount: formData?.discounts?.reduce((acc, discount) => {
            //   const value =
            //     discount.type === 1
            //       ? (Number(formData.BillAmount) * Number(discount.discount)) /
            //         100
            //       : Number(discount.discount);
            //   return acc + value;
            // }, 0),
            discount: 0,
            due: numberInvoiceAmount,
          },
          isModify: false,
          status:
            status == "draft"
              ? 1
              : status == "save"
                ? 2
                : undefined || undefined,
          category: formData.PayableCategory || undefined,
          type: formData.PayableType || undefined,
          mailAddress: formData.MailingAddress || undefined,
          contacts: formData.InvoiceContacts || undefined,
          emails: formData.InvoiceContactEmails || undefined,
          invoiceDetails: tableData.map((item) => ({
            service: item.productService || undefined,
            description: item.Description || undefined,
            quantity: Number(item.Quantity) || undefined,
            rate: Number(item.Rate) || undefined,
            amount: Number(item.Amount) || undefined,
            // entityId: Number(item?.Client?.value) || undefined,
            // entityType: item?.Client?.coll || undefined,
            clientId:
              item?.Client?.coll === "Client"
                ? Number(item?.Client?.value)
                : undefined,
            vendorId:
              item?.Client?.coll === "Vendor"
                ? Number(item?.Client?.value)
                : undefined,
          })),
          discount:
            formData.discounts.map((item) => ({
              name: item.name || undefined,
              type: item.type || undefined,
              value: Number(item.discount) || undefined,
            })) || undefined,
          // discount: [
          //   {
          //     name: "",
          //     type: null,
          //     value: 0,
          //   },
          // ],
          memo: formData.StatmentMemo || undefined,
          comments: formData.Comments || undefined,
          // documents: [],
          addedBy: loginUserUiid,
          onSuccess: async (resData) => {
            dispatch(setAccountPayablesProfile(payload));
            // for file upload
            if (
              Array.isArray(formData?.attachments) &&
              formData.attachments.some(
                (attachment) =>
                  Array.isArray(attachment.chooseFiles) &&
                  attachment.chooseFiles.length > 0,
              )
            ) {
              navigate(-1);
              const cleanAttachments = formData.attachments.filter(
                (att) => att.chooseFiles && att.chooseFiles.length > 0,
              );
              // Map files with their parent doc id
              const cleanAttachmentsFiles = cleanAttachments.flatMap((doc) =>
                doc.chooseFiles.map((file) => {
                  file.id = doc.id;
                  return file;
                }),
              );
              dispatch(
                uploadStart({
                  uploadType: "multiple",
                  field: "doc",
                  coll: "AccountPayable",
                  uiid: resData.data.payableId,
                  entity: "accountPayables",
                  category: "AccountPayable",
                  doc: cleanAttachmentsFiles,
                  onSuccess: async (fileData) => {
                    dispatch(
                      addDocumentStart({
                        coll: "Document",
                        refColl: "AccountPayable",
                        refId: resData.data.payableId,
                        // refField: `documents.$[elem].list`,
                        refField: `documents`,
                        // refPatchId: updateRes.targetPatchId,
                        isRefFieldArray: true,
                        payload: {
                          addedBy: loginUserUiid,
                          attachments: [
                            {
                              addedBy: loginUserUiid,
                              parent: {
                                client: formData.Vendor.value,
                              },
                              docType: "AccountsPayable",
                              // docType: formData.documentType.value,
                              ref: {
                                id: resData.data.payableId,
                                entity: "AccountPayable",
                                path: `documents`,
                              },
                              file: formData.attachments.map((obj) => ({
                                // id: obj.id,
                                name: obj.title,
                                // comments: obj.attachmentComments,
                                // status: obj.documentStatus,
                                // expiry: obj.expiryDate,
                                // addedBy: loginUserUiid,
                                keys: fileData.map((file) => file.key),
                              })),
                            },
                          ],
                        },
                        onSuccess: (docRes) => {
                          // dispatch(
                          //   getClientOneStart({
                          //     clientUiid: clientProfileUiid,
                          //     retrieve: `documents`,
                          //     ref: "Document",
                          //   })
                          // );
                          // mainBackTab()
                        },
                      }),
                    );
                  },
                }),
              );
            } else {
              navigate(-1);
            }
          },
        };
        dispatch(
          addAccountPayablesStart({
            ...payload,
          }),
        );
      }
    } else {
      showToast("Please complete all required fields before submitting the bill", "error", 2000);
    }
  };

  const columns = [
    {
      key: "productService",
      label: "Product/Service",
      render: (row) => (
        <div>
          {row.editing || row.editable ? (
            <CustomInput
              type="text"
              title=""
              size="xs"
              placeholder="Enter Name"
              value={row.productService || ""}
              onChange={(value) =>
                handleRowChange(row.id, "productService", value)
              }
            />
          ) : (
            <div className="flex items-center gap-3 group">
              <div>{row?.productService}</div>
              <div
                className={`flex items-center opacity-0 group-hover:opacity-100 transition-opacity duration-200 ${
                  row?.productService === "-" ? "invisible" : "visible"
                }`}
              >
                <CopyToClipboard
                  tooltipPosition={"right"}
                  title={"Statement Memo"}
                  content={row?.productService}
                />
              </div>
            </div>
          )}
        </div>
      ),
    },
    {
      key: "Description",
      label: "Description",
      render: (row) => (
        <div>
          {row.editing || row.editable ? (
            <CustomInput
              type="text"
              placeholder="Enter details"
              title=""
              size="xs"
              value={row.Description || ""}
              onChange={(value) =>
                handleRowChange(row.id, "Description", value)
              }
            />
          ) : (
            <div className="flex items-center gap-3 group">
              <div>{row?.Description}</div>
              <div
                className={`flex items-center opacity-0 group-hover:opacity-100 transition-opacity duration-200 ${
                  row?.Description === "-" ? "invisible" : "visible"
                }`}
              >
                <CopyToClipboard
                  tooltipPosition={"right"}
                  title={"Statement Memo"}
                  content={row?.Description}
                />
              </div>
            </div>
          )}
        </div>
      ),
    },
    {
      key: "Quantity",
      label: "Quantity",
      render: (row) => (
        <div>
          {row.editing || row.editable ? (
            <CustomInput
              type="text"
              title=""
              size="xs"
              placeholder="Enter value"
              value={row.Quantity || ""}
              onChange={(value) => handleRowChange(row.id, "Quantity", value)}
            />
          ) : (
            <span>{row.Quantity}</span>
          )}
        </div>
      ),
    },
    {
      key: "Rate",
      label: "Rate",
      render: (row) => (
        <div>
          {row.editing || row.editable ? (
            <CustomInput
              type="text"
              title=""
              size="xs"
              placeholder="Enter value"
              value={row.Rate || ""}
              onChange={(value) => {
                handleRowChange(row.id, "Rate", value);
                handleRowChange(row.id, "Amount", value * row.Quantity);
              }}
            />
          ) : (
            <span>{formatCurrency(row.Rate)}</span>
          )}
        </div>
      ),
    },

    {
      key: "Amount",
      label: "Amount",
      render: (row) => (
        <div>
          {row.editing || row.editable ? (
            <CustomInput
              type="text"
              title=""
              size="xs"
              placeholder="Enter value"
              value={row.Amount || ""}
              onChange={(value) => handleRowChange(row.id, "Amount", value)}
            />
          ) : (
            <span>{formatCurrency(row.Amount)}</span>
          )}
        </div>
      ),
    },

    {
      key: "Client",
      label: "Client",
      render: (row) => (
        <div>
          {row.editing || row.editable ? (
            // <CustomSelect
            <FormFieldSet
              // type="select"
              // type="allClientsSorted"
              type="allClientsList"
              // parentValue={{ or }}
              placeholder="Select Placement"
              // title=""
              noTitle
              size="xs"
              value={row?.Client?.label || ""}
              onChange={(value) => handleRowChange(row.id, "Client", value)}
              keyname="allClients"
              showSearch
              key={row.id}
              // options={[
              //   { value: "Placement 1", label: "Placement 1" },
              //   { value: "Placement 2", label: "Placement 2" },
              //   { value: "Placement 3", label: "Placement 3" },
              // ]}
            />
          ) : (
            <span>{formatWords2(row?.Client?.label) || ""}</span>
          )}
        </div>
      ),
    },

    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className="flex items-center gap-2 flex-row">
          {row.editable && (
            <Button
              type="icon"
              icon="edit_square"
              size="xs"
              variant="text"
              color="black"
              onClick={() => handleEditRow(row.id)}
            />
          )}
          {row.editable && (
            <Button
              type="icon"
              icon="delete"
              size="xs"
              variant="text"
              color="black"
              onClick={() => handleRemoveRow(row.id)}
            />
          )}
          <Button
            type="icon"
            icon="more_vert"
            size="xs"
            variant="text"
            color="black"
            // onClick={() => setMoreActionModal(!moreActionModal)}
            onClick={handelinvoice}
          />
        </div>
      ),
    },
  ];
  const handleSelectTimeDate = (data) => {
    setSelectedValues(data);
  };
  return (
    <div className="flex-1 flex gap-2 h-full overflow-hidden">
      <div
        className={`border-[1px] border-neutrals-50 rounded p-3 mt-2 overflow-auto ${
          formData.Contractors.value ? "w-[80%] " : "w-full"
        }`}
      >
        <DevNote>
          <h5>{`Editing ${payableId} - ${
            currentAccountsPayables.uiid || "adding..."
          }`}</h5>
          <h5>Payrate of vendor selected placement{currentPlacementPayRate}</h5>
        </DevNote>
        <Backdrop isOpen={loading || timeSheetLoading}>
          <LogoLoader />
        </Backdrop>
        <div>
          <PageHeader
            Section={
              <div className="flex gap-3">
                <PageTitle
                  title={payableId ? "Edit AP Invoice" : "Create AP Invoice"}
                  tag="h5"
                  size={"sm"}
                />
                <Tag
                  title="Tektree"
                  variant="outlined"
                  className=" !text-neutrals !py-1.5"
                />
              </div>
            }
            RightSection={
              <div className="flex gap-3">
                <Button
                  size="sm"
                  title={"Back"}
                  icon={"arrow_left_alt"}
                  onClick={handleBack}
                />
                <Button size="sm" title={"Available Credits"} />
              </div>
            }
          />
        </div>
        <div className="flex justify-end mt-2 w-full">
        <div className="min-w-60">
            <InfoCardNewAdv
              title=" Invoice Amount"
              color="primary"
              value={formatCurrency(Number(invoiceAmount))}
              // suffix={"USD"}
              layout="option4"
              titleConfig={{className:"font-bold"}}
              isLoading={loading}
            />
          </div>
          </div>

        <div className="grid grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 max-w-9xl gap-x-10 gap-y-6 mt-4">
          <FormFieldSet
            type="select"
            title=" Payable Category"
            options={PayableCategory}
            placeholder="Select Payable Category"
            value={formData.PayableCategory}
            onChange={(value) => handleChange("PayableCategory", value)}
            error={errors.PayableCategory}
          />
          <FormFieldSet
            type="select"
            title=" Payable Type"
            placeholder="Select PayableType"
            options={PayableType}
            value={formData.PayableType}
            onChange={(value) => handleChange("PayableType", value)}
            error={errors.PayableType}
          />
          <div>
            <div className="text-[12px] font-medium mb-0.5 min-h-[18px]">
              <div className="text-[12px] font-medium mb-0.5 min-h-[18px]">
                Approval Flow
              </div>
            </div>
            {formData?.ApprovalFlow?.label && (
              <Chip
                sixe="xs"
                label={`${formatWords2(formData.ApprovalFlow.label) || ""}`}
                className="m-1"
              />
            )}
          </div>
          
          <FormFieldSet
            type="select"
            title=" Invoice By"
            placeholder="Select Invoice By"
            options={InvoiceBy}
            value={formData.InvoiceBy}
            onChange={(value) => handleChange("InvoiceBy", value)}
            error={errors.InvoiceBy}
          />
          <FormFieldSet
            type="allVendorsList"
            title=" Vendor"
            placeholder="Select Vendor"
            value={
              formData?.Vendor?.label
                ? formData.Vendor.label
                : formData?.Vendor?.uiid
                  ? `${formData?.Vendor?.businessName || ""} | ${getVendorId(
                      formData?.Vendor?.uiid || "",
                    )}`
                  : ""
            }
            showSearch
            onChange={(value) => {
              handleChange("Vendor", value);
              handleChange("Contractors", "");
              handleChange("ApprovalFlow", "");
            }}
            error={errors.Vendor}
          />
          <FormFieldSet
            type="placementsWithEmployeeName"
            title="Contractors"
            placeholder="Enter Contractors"
            value={
              formData?.Contractors?.label
                ? formData.Contractors.label
                : formData?.Contractors?.[0]
                  ? `${formData.Contractors[0].firstName || ""} ${
                      formData.Contractors[0].lastName || ""
                    } | (${getEmployeeId(
                      formData.Contractors[0].uiid || "",
                      formData.Contractors[0].employeementType || "",
                    )})`
                  : ""
            }
            showSearch
            parentValue={{
              entityId: formData.Vendor?.value || formData?.Vendor?.uiid,
              entityType: "Vendor",
            }}
            onChange={(value) => {
              const lastpastpayrate = Array.isArray(value.payments)
                ? value.payments[value.payments.length - 1]
                : [];
              setCurrentPlacementPayRate(
                lastpastpayrate.payRate.payRatePerHour || 0,
              );
              setCurrentTimesheetFetchingType(value?.source || "");
              setCurrentPlacementId(value?.placementId || "");
              setPlacementLastPay(value?.lastPay || {});
              handleChange("Contractors", value);
            }}
            error={errors.Contractors}
            disabled={
              formData?.Vendor?.value || formData?.Vendor?.uiid ? false : true
            }
          />
        </div>
        <div className="grid grid-cols-1 xl:grid-cols-3 2xl:grid-cols-4 max-w-9xl gap-x-10 gap-y-6 mt-4">
          <FormFieldSet
            type="textArea"
            title=" Mailing Address"
            placeholder="Enter Mailing Address"
            value={formData.MailingAddress}
            onChange={(value) => handleChange("MailingAddress", value)}
            error={errors.MailingAddress}
            rows={6}
            disabled={true}
          />
        </div>
        <div className="grid grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 max-w-9xl gap-x-10 gap-y-6 mt-4">
          <FormFieldSet
            type="text"
            title=" Invoice Number"
            placeholder=" Enter Invoice Number"
            value={formData.InvoiceNumber}
            onChange={(value) => handleChange("InvoiceNumber", value)}
            error={errors.InvoiceNumber}
            required
          />
          <FormFieldSet
            type="select"
            title="Net Terms"
            placeholder="Net Terms"
            value={formData.NetTerms}
            onChange={(value) => handleChange("NetTerms", value)}
            error={errors.NetTerms}
            disabled={true}
          />
        </div>
        <div className="grid grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 max-w-9xl gap-x-10 gap-y-6 mt-4">
          <FormFieldSet
            type="datepicker"
            title=" Bill Date"
            placeholder="Bill Date"
            value={formData.BillDate}
            onChange={(value) => {
              const str = vendorDetails?.generalInfo?.netTerms;
              let num = null;
              let isPayOnPay = false;

              if (
                ["pay on pay", "due on receipt"].some(
                  (list) => str?.toLowerCase() === list,
                )
              ) {
                isPayOnPay = true;
              } else {
                const match = str?.match(/^net\s*(\d+)$/i);
                num = match ? parseInt(match[1]) : null;
              }

              handleChange("BillDate", value);

              if (value) {
                if (isPayOnPay) {
                  handleChange("DueDate", value);
                } else {
                  const billDate = new Date(value);
                  const dueDate = new Date(billDate);
                  if (num !== null) {
                    dueDate.setDate(dueDate.getDate() + num);
                  }
                  handleChange("DueDate", dueDate.toISOString().split("T")[0]);
                }
              }
            }}
            error={errors.BillDate}
            showDropdown={false}
          />
          <FormFieldSet
            type="datepicker"
            title=" Due Date"
            placeholder="DueDate"
            value={formData.DueDate}
            onChange={(value) => handleChange("DueDate", value)}
            error={errors.DueDate}
            //as told by mahendar
            disabled={true}
            showDropdown={false}
          />
        </div>
        <div className="grid grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 max-w-9xl gap-x-10 gap-y-6 mt-4">
          <FormFieldSet
            type="text"
            title=" Bill Amount"
            placeholder="Enter  Bill Amount"
            value={formData.BillAmount}
            onChange={(value) => handleChange("BillAmount", value)}
            error={errors.BillAmount}
            required
          />
          <div>
            <div className="text-[12px] font-medium mb-0.5 min-h-[18px]">
              <div className="text-[12px] font-medium mb-0.5 min-h-[18px]">
                Invoice Contacts
              </div>
            </div>
            {formData.InvoiceContacts
              ? formData.InvoiceContacts?.map((data, index) => (
                  <Chip
                    key={`contact-${index}`}
                    sixe="xs"
                    label={`${data.code}-${data.number}`}
                    className="m-1"
                  />
                ))
              : ""}
          </div>
          <div>
            <div className="text-[12px] font-medium mb-0.5 min-h-[18px]">
              Invoice Contact Emails
            </div>
            {formData.InvoiceContactEmails
              ? formData.InvoiceContactEmails?.map((data, index) => (
                  <Chip key={`email-${index}`} sixe="xs" label={data} className="m-1" />
                ))
              : ""}
          </div>
        </div>
        <div className="flex items-center justify-between mt-5">
          <p> Invoice Details</p>
          <Button
            size="sm"
            title="Add"
            onClick={handleAddRow}
            color="black"
            icon="add"
          />
        </div>

        <Divider />
        <div className="mt-3">
          <NewTable
            rows={tableData}
            columns={columns}
            hideToolBar
            showSlNo
            limit={50}
          />
        </div>

        <div>
          <InvoicedetailsModal open={model} onClose={() => setmodel(!model)} />
        </div>
        <div className="mt-4">
          <p>Notes & Total </p>
          <Divider />
        </div>
        <div className=" mt-2">
          <div className="flex flex-col items-end gap-2">
            <div className="flex items-center gap-2">
              Subtotal:
              <div className="bg-black text-white pl-3 pr-2 py-2">
                {/* {(Number(formData?.BillAmount).toFixed(2))} USD */}
                {formatCurrency(formData?.BillAmount)}
              </div>
            </div>
            <div className="flex flex-col gap-4 items-start w-full">
              {formData?.discounts?.map((discount) => (
                <div
                  key={discount.id}
                  className="grid grid-cols-2 items-start lg:grid-cols-[repeat(3,1fr)_0.6fr] gap-6 mt-3 w-full"
                >
                  <div className="flex-1">
                    <FormFieldSet
                      type="text"
                      noTitle={true}
                      value={discount.name}
                      placeholder="Name"
                      onChange={(value) =>
                        handleDiscountFieldChange(discount.id, "name", value)
                      }
                      disabled={!discount.editable}
                    />
                  </div>
                  <div className="flex-1">
                    <FormFieldSet
                      type="select"
                      noTitle={true}
                      value={discount.type}
                      placeholder="Select"
                      onChange={(value) =>
                        handleDiscountFieldChange(discount.id, "type", value)
                      }
                      options={[
                        { label: "Percentage", value: 1 },
                        { label: "Value", value: 2 },
                      ]}
                      disabled={!discount.editable}
                    />
                  </div>
                  <div className="flex-1">
                    <FormFieldSet
                      type="text"
                      title=""
                      placeholder="Discount"
                      noTitle={true}
                      value={discount.discount}
                      onChange={(value) =>
                        handleDiscountFieldChange(
                          discount.id,
                          "discount",
                          value,
                        )
                      }
                      disabled={!discount.editable}
                    />
                  </div>
                  <div className="mt-3 flex gap-2">
                    <Button
                      type="icon"
                      icon="add"
                      size="xs"
                      color="black"
                      onClick={handleAddDiscount}
                    />
                    <Button
                      type="icon"
                      icon="remove"
                      size="xs"
                      color="danger"
                      onClick={() =>
                        handleRemoveDiscount(discount.id, discount.editable)
                      }
                    />
                    <div className="text-gray-600">
                      {discount.type === 1
                        ? `${Number(discount.discount).toFixed(2)}% (${(
                            (Number(formData.BillAmount) *
                              Number(discount.discount)) /
                            100
                          ).toFixed(2)} USD)`
                        : `${Number(discount.discount).toFixed(2)} USD`}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="flex gap-2 mt-3 hidden">
              discount Total:
              {/* <div>
                  USD
                </div> */}
              <div>
                {formData?.discounts?.reduce((acc, discount) => {
                  const value =
                    discount.type === 1
                      ? formatCurrency(
                          (Number(formData.BillAmount) *
                            Number(discount.discount)) /
                            100,
                        )
                      : formatCurrency(Number(discount.discount));

                  return acc + value;
                }, 0)}
                USD
              </div>
            </div>
            <div className="min-w-34 ">
              <Divider />
              <div className="flex justify-end ">
                <p>
                  Grand Total{" "}
                  {/* <span className="ml-7">{formatCurrency(invoiceAmount)} </span> */}
                  <span className="ml-7">
                    {formatCurrency(formData?.BillAmount)}{" "}
                  </span>
                </p>
              </div>
            </div>
            {billpayments.length > 0 &&
              billpayments.map((pay, index) => (
                <div className="min-w-72 m-4">
                  <div className="flex justify-end ">
                    <p className="text-blue-400">
                      <span className="text-blue-400">
                        {`Payment on ${new Date(
                          pay?.TxnDate,
                        ).toLocaleDateString("en-US")}`}
                      </span>
                      <span className="ml-7">
                        -{formatCurrency(Number(pay?.TotalAmt || 0))}{" "}
                      </span>
                    </p>
                  </div>
                </div>
              ))}
            {payableId && (
              <div className="min-w-72 m-4">
                <Divider />
                <div className="flex justify-end ">
                  <p>
                    Invoice Total:{" "}
                    <span className="ml-7">
                      {formatCurrency(
                        currentAccountsPayables?.amounts?.billed,
                      )}{" "}
                    </span>
                  </p>
                </div>
              </div>
            )}
            {payableId && (
              <div className="min-w-72 m-4">
                <Divider />
                <div className="flex justify-end ">
                  <p>
                    Due Total:{" "}
                    <span className="ml-7">
                      {formatCurrency(
                        currentAccountsPayables?.amounts?.due,
                      )}{" "}
                    </span>
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="grid grid-cols-2 xl:grid-cols-3 max-w-9xl gap-x-10 gap-y-6 mt-4">
          <FormFieldSet
            type="textArea"
            title="Comments"
            placeholder="Enter Comments"
            value={formData.Comments}
            onChange={(value) => handleChange("Comments", value)}
            error={errors.Comments}
          />
          <FormFieldSet
            type="textArea"
            title=" Statment Memo"
            placeholder="Enter Statment Memo"
            value={formData.StatmentMemo}
            onChange={(value) => handleChange("StatmentMemo", value)}
            error={errors.StatmentMemo}
          />
        </div>

        <div className="flex items-center justify-between mt-5">
          <p>Documents</p>
        </div>
        <Divider />
        <div>
          {/* <DocumentsList data={docs || []} type="modal" /> */}
          <DocumentsList data={docs || []} type="inner" />

          {formData.attachments.map((row, index) => (
            <div
              key={row.id}
              className="grid grid-cols-[repeat(2,1fr)_50px] xl:grid-cols-[repeat(3,1fr)_50px] gap-4 px-1 py-4"
            >
              <div className="flex-1">
                <FormFieldSet
                  type="text"
                  placeholder="Title"
                  title={""}
                  value={row.title}
                  onChange={(value) => handleFieldChange(index, "title", value)}
                  error={getAttachmentError(index, "title")}
                />
              </div>
              <div className="flex-1">
                <FormFieldSet
                  type="file"
                  title=""
                  multiple
                  placeholder="Choose File"
                  value={row.chooseFiles}
                  onChange={(value) =>
                    handleFieldChange(index, "chooseFiles", value)
                  }
                  error={getAttachmentError(index, "chooseFiles")}
                />
              </div>
              <div className="flex gap-2 mt-8">
                <Button
                  type="icon"
                  size="xs"
                  icon="add"
                  color="black"
                  onClick={handleAddRowattach}
                />
                <Button
                  type="icon"
                  size="xs"
                  icon="remove"
                  color="danger"
                  onClick={() => handleRemoveRowattach(row.id)}
                  disabled={formData.attachments.length === 1}
                />
              </div>
            </div>
          ))}
        </div>
        <div className="flex gap-3 justify-end my-6">
          <Button
            title="Cancel"
            variant="outlined"
            onClick={() => navigate(-1)}
          />
          <Button title="Draft" onClick={() => handleSave("draft")} />
          <Button
            title={payableId ? "Update" : "Proceed"}
            onClick={() => handleSave("save")}
          />
        </div>
      </div>
      {formData.Contractors.value ? (
        <div className="flex-1 border-[1px] border-neutrals-50 rounded p-3 mt-2 w-[20%] h-full overflow-auto">
          {/* only show all timeshgeets in singledropdown as per  new requiremnet */}
          {/* <InvoiceSidebar */}
          <InvoiceSidebar2
            data={[
              {
                uiid: uuidv4(),
                // type: 1,
                // companyName: "XYZ",
                empName: formatWords2(formData?.Contractors?.label) || "",
                ranges:
                  timesheets?.data
                    ?.filter((entry) => entry.status === 6)
                    ?.map((entry) => ({
                      from: entry.period?.from,
                      to: entry.period?.to,
                      type: entry.periodCycle,
                      uiid: entry.uiid,
                      // uiid: uuidv4(),
                      dailyEntries: entry.dailyEntries.map((d) => ({
                        _id: d._id,
                        date: d.date,
                        st: d.st,
                        tbh: d.tbh,
                        th: d.th,
                        eventType: d.eventType,
                      })),
                    })) || [],
              },
            ]}
            selectedValues={selectedValues}
            handleSelectTimeDate={handleSelectTimeDate}
          />
        </div>
      ) : null}
    </div>
  );
};
export default CreateAccountsPayableInvoice;
